import { Route, Routes } from "react-router-dom";
import About from "../pages/About";
import NFTVerification from "../pages/NFTVerification";
import ProfilePage from "../pages/Profile";
import Drop from "../pages/Drop";
import Admin from "../pages/Admin";
import CheckoutPage from "../pages/CheckoutPage";
import PaymentStatus from "../components/stripe-payment/PaymentStatus";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import MetaMaskInstalled from "../pages/component/MetaMaskInstalled";
import LandingPage from "../pages/LandingPage";

const Content = () => {
  return (
    <>
      <MetaMaskInstalled />
      <Routes>
        <Route exact path="/about-us" element={<About />} />
        <Route exact path="/admin" element={<Admin />} />
        {/* <Route path="/" element={<About />} /> */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/verify-nft" element={<NFTVerification />} />
        <Route path="/profile" element={<ProfilePage />} />
        {/* <Route path="/drop" element={<Drop />} /> */}
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/landing-page" element={<LandingPage />} />
      </Routes>
    </>
  );
};

export default Content;
